import { LinkComponent } from '@/modules/navigation';
import {
	Card, Center, Icon, Stack, Text, type CardRootProps,
} from '@chakra-ui/react';
import React from 'react';

export type SocialMediaCardProps = {
	label: string;
	link:  string;
	href:  string;
	icon:  React.ReactNode;
} & CardRootProps;

const SocialMediaCard = ({
	label, href, link, icon, ...cardRootProps
}: SocialMediaCardProps) => {
	return (
		<Card.Root {...cardRootProps}>
			<Card.Body p={4}>
				<Center h={'100%'} w={'100%'}>
					<Stack alignItems={'center'} gap={6} justifyContent={'space-between'}>
						<Icon>
							{icon}
						</Icon>
						<Stack gap={1}>
							<Text fontSize={'14px'} fontWeight={'semibold'} textAlign={'center'}>{label}</Text>
							<LinkComponent
								isNewTab
								color={'gray.700'}
								href={href}
								textStyle={'p4'}
							>
								{link}
							</LinkComponent>
						</Stack>
					</Stack>
				</Center>
			</Card.Body>
		</Card.Root>
	);
};

export default SocialMediaCard;